export interface Channel {
  key: string;
  name: string;
  short: string;
  tagline: string;
  desc: string;
  icon: string;
  color: string;
  cover: string;
}

export const channels: Channel[] = [
  {
    key: "wanghong",
    name: "新晋网红黑料",
    short: "网红",
    tagline: "涨粉速度与人设崩塌速度一样快",
    desc: "聚焦新晋网红的起号内幕、团队包装与翻车现场，还原镜头之外的真实一面。",
    icon: "ri-smartphone-line",
    color: "primary",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photography%20of%20a%20glowing%20smartphone%20held%20by%20silhouette%20hand%20in%20front%20of%20ring%20light%2C%20live%20streaming%20studio%20setup%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20dark%20background%20with%20soft%20bokeh%20lights%2C%20moody%20and%20dramatic%2C%20high%20detail%20editorial%20style&width=1200&height=760&seq=chan-wanghong&orientation=landscape",
  },
  {
    key: "yiren",
    name: "小艺人黑历史",
    short: "艺人",
    tagline: "从练习生到出道，翻旧账比翻热搜还快",
    desc: "挖掘十八线小艺人的陈年旧事与出道前后的反差，看清光环背后的另一副面孔。",
    icon: "ri-star-smile-line",
    color: "accent",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photography%20of%20an%20empty%20red%20carpet%20stage%20with%20spotlight%20beams%20and%20glowing%20marquee%20lights%20at%20night%2C%20dramatic%20warm%20gold%20and%20crimson%20tones%2C%20no%20people%2C%20moody%20atmosphere%2C%20high%20detail%20magazine%20style&width=1200&height=760&seq=chan-yiren&orientation=landscape",
  },
  {
    key: "lianxisheng",
    name: "练习生爆料",
    short: "练习生",
    tagline: "镜头背后，是漫长的练习室与暗涌",
    desc: "从训练、选秀到出道淘汰，练习生群体那些不为人知的选拔内幕与规则。",
    icon: "ri-mic-line",
    color: "primary",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photography%20of%20an%20empty%20dance%20rehearsal%20studio%20with%20full%20length%20mirrors%20and%20a%20single%20spotlight%2C%20warm%20amber%20lighting%20with%20dust%20particles%20in%20air%2C%20moody%20dramatic%20atmosphere%2C%20no%20people%2C%20high%20detail%20magazine%20style&width=1200&height=760&seq=chan-lianxisheng&orientation=landscape",
  },
  {
    key: "yanyuan",
    name: "新人演员翻车",
    short: "演员",
    tagline: "一部戏把人设演没，翻车只需一个镜头",
    desc: "盘点新人演员的台词翻车、演技塌房与剧组风波，聊聊镜头背后的营业事故。",
    icon: "ri-clapperboard-line",
    color: "accent",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photography%20of%20a%20film%20clapperboard%20and%20director%20monitor%20on%20a%20movie%20set%20with%20warm%20practical%20lights%20and%20camera%20silhouettes%2C%20dusty%20golden%20backlight%2C%20no%20people%2C%20moody%20magazine%20style&width=1200&height=760&seq=chan-yanyuan&orientation=landscape",
  },
  {
    key: "suren",
    name: "素人变网红黑幕",
    short: "素人",
    tagline: "一条视频爆红背后，藏着一整套造星工厂",
    desc: "起底素人一夜爆红背后的脚本、投放与商业运作，拆穿看似偶然的流量密码。",
    icon: "ri-user-heart-line",
    color: "primary",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photography%20of%20a%20quiet%20street%20crossing%20into%20a%20bright%20glowing%20studio%20doorway%2C%20silhouette%20transition%20theme%2C%20warm%20crimson%20and%20gold%20contrast%2C%20dramatic%20light%2C%20no%20identifiable%20people%2C%20moody%20magazine%20style&width=1200&height=760&seq=chan-suren&orientation=landscape",
  },
];